import {Rule, StyleSheet} from "jss";

let ruleCounter = 0;

// Fixes some weird render errors caused by duplicate class names
// See https://github.com/mui-org/material-ui/issues/8223 for more information
export default function createGenerateClassName<Name extends string = any>() {
  return (rule: Rule, sheet?: StyleSheet<Name>) => {
    ruleCounter += 1;

    if (import.meta.env.PROD) {
      return `c${ruleCounter}`;
    }

    // @ts-ignore
    if (sheet && sheet.options.meta) {
      // @ts-ignore
      return `${sheet.options.meta}-${rule.key}-${ruleCounter}`;
    }

    // @ts-ignore
    return `${rule.key}-${ruleCounter}`;
  };
}
